import {
	DROPS_BANNER_HEADER_MODULE_ID,
	DROPS_LIST_MODULE_ID,
} from 'root/src/shared/descriptions/modules/moduleIds'
import SportsEsportsIcon from '@material-ui/icons/SportsEsports'
import CheckCircle from 'root/src/client/public/ic-check-circle'
import VpnKeyIcon from '@material-ui/icons/VpnKey'
import { GET_DROP_EVENTS } from 'root/src/shared/descriptions/endpoints/endpointIds'
import {
	liveEventsKey,
	getComingSoonEventsKey,
	getPrivateLiveEventsKey,
} from 'root/src/shared/constants/keys'

export default {
	[DROPS_BANNER_HEADER_MODULE_ID]: {
		moduleType: 'bannerHeader',
		bannerImageText: 'Key Drops',
		bannerImageSubText: 'Earn Keys for your Fans by Completing Dares for these Games',
		listModuleId: DROPS_LIST_MODULE_ID,
		fullWidth: true,
		bannerTabs: [
			{
				id: 1,
				tabLabel: 'Live',
				endpointId: [GET_DROP_EVENTS],
				fixedPayload: {
					section: liveEventsKey,
					pageItemLength: 20,
				},
			},
			{
				id: 2,
				tabLabel: 'Coming soon',
				endpointId: [GET_DROP_EVENTS],
				fixedPayload: {
					section: getComingSoonEventsKey,
					pageItemLength: 8,
				},
			},
			{
				id: 3,
				tabLabel: 'Private',
				endpointId: [GET_DROP_EVENTS],
				fixedPayload: {
					section: getPrivateLiveEventsKey,
					pageItemLength: 8,
				},
			},
		],
		bannerBoxImages: [
			{
				text: 'Find Games to Play on Stream',
				image: SportsEsportsIcon,
			},
			{
				text: 'Accept Dares for Your Key',
				image: CheckCircle,
			},
			{
				text: 'Deliver and Giveaway Keys',
				image: VpnKeyIcon,
			},
		],
	},
}
